import React from 'react';
import PropTypes from 'prop-types';
import styles from './ModalParts.module.scss';

/* ────────────────────────────────────────────────────────────
 * ModalField — labeled wrapper for a control inside ModalGrid.
 *
 * Provides the consistent uppercase meta label, required-star,
 * and below-control hint slot every modal in the app uses.
 *
 *   <ModalField
 *     label="Menu name"
 *     required
 *     htmlFor="menu-name"
 *     hint={cloneStatus}
 *   >
 *     <Input id="menu-name" ... />
 *   </ModalField>
 *
 * `fullWidth` makes the field span every column of the parent
 * ModalGrid (useful for description textareas).
 * ──────────────────────────────────────────────────────────── */

const ModalField = ({
  label,
  required,
  htmlFor,
  hint,
  fullWidth,
  children,
  className,
}) => (
  <div
    className={[
      styles.field,
      fullWidth ? styles.fieldFull : '',
      className || '',
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {label && (
      <label className={styles.label} htmlFor={htmlFor}>
        {label}
        {required && (
          <span className={styles.required} aria-hidden="true">
            *
          </span>
        )}
      </label>
    )}
    {children}
    {hint && <span className={styles.hint}>{hint}</span>}
  </div>
);

ModalField.propTypes = {
  label: PropTypes.node,
  required: PropTypes.bool,
  htmlFor: PropTypes.string,
  hint: PropTypes.node,
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalField.defaultProps = {
  label: null,
  required: false,
  htmlFor: undefined,
  hint: null,
  fullWidth: false,
  children: null,
  className: '',
};

export default ModalField;
